module.exports = __webpack_public_path__ + "static/media/level-2.c758b6ae.glb";